var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "aviso-2fa", attrs: { id: "aviso-2fa" } }, [
    _c("div", { staticClass: "d-flex" }, [
      _c(
        "div",
        { staticClass: "aviso-2fa__icono mr-3" },
        [
          _c("font-awesome-icon", {
            attrs: { icon: "shield-alt", size: "lg" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-grow-1" },
        [
          _c("h6", {
            staticClass: "aviso-2fa__titulo",
            domProps: {
              textContent: _vm._s(_vm.$t("manuales.aviso2fa.titulo")),
            },
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "aviso-2fa__texto",
            domProps: {
              textContent: _vm._s(_vm.$t("manuales.aviso2fa.descripcion")),
            },
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "aviso-2fa__texto",
            domProps: {
              textContent: _vm._s(_vm.$t("manuales.aviso2fa.instruccion")),
            },
          }),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "aviso-2fa__boton",
              attrs: { id: "btn-consultar-guia-2fa", size: "sm" },
              on: {
                click: function ($event) {
                  return _vm.abrirGuia()
                },
              },
            },
            [
              _c("font-awesome-icon", {
                staticClass: "text-danger mr-1",
                attrs: { icon: "file-pdf" },
              }),
              _vm._v(" "),
              _c("span", {
                domProps: {
                  textContent: _vm._s(_vm.$t("manuales.aviso2fa.boton")),
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }